import type { CurrencyCode } from '@shared/hooks/useGeoLocale';
import { usePrintCurrency } from '@apps/card/hooks/usePrintCurrency';

/**
 * Geo currency narrowed to the currencies stationery can actually be sold in.
 *
 * Thin alias over {@link usePrintCurrency} — kept for its existing call sites. Prefer
 * `usePrintCurrency` in new code; it also exposes the setter.
 *
 * Always returns a print-supported currency (unsupported → USD), so callers no longer
 * need their own fallback.
 */
export const useCardGeoCurrency = (): CurrencyCode => {
  return usePrintCurrency().currency;
};
